var DataManager = /** @class */ (function () {
    function DataManager(serviceCall, storageManager, key) {
        this._storageManager = storageManager;
        this._serviceCall = serviceCall;
        this._key = key;
        //this.updateDataFromDisk(() => {});
    }
    DataManager.prototype.setServiceCall = function (serviceCall) {
        this._serviceCall = serviceCall;
    };
    DataManager.prototype.updateDataFromDisk = function (callback) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._storageManager
                .fetch(_this._key)
                .then(function (value) {
                if (value) {
                    _this._data = value;
                    callback(_this._data);
                }
                resolve(true);
            });
        });
    };
    DataManager.prototype.getFreshData = function (onComplete, isConnected, onFailed) {
        var _this = this;
        if (onComplete === void 0) { onComplete = function () { }; }
        if (onFailed === void 0) { onFailed = function () { }; }
        if (isConnected) {
            this._serviceCall(function (data) {
                _this.handleServiceCallback(data, onComplete, onFailed);
            });
        }
    };
    DataManager.prototype.getData = function (onComplete, isConnected, onFailed) {
        var _this = this;
        if (onComplete === void 0) { onComplete = function () { }; }
        if (onFailed === void 0) { onFailed = function () { }; }
        // Si on a en mémoire, on envoie
        if (this._data) {
            onComplete(this._data);
        }
        else {
            // On continue en allant chercher sur le disque
            this.updateDataFromDisk(onComplete).then(function () {
                // Finalement on fait appel au service si on peut
                if (isConnected) {
                    _this._serviceCall(function (data) {
                        _this.handleServiceCallback(data, onComplete, onFailed);
                    });
                }
            });
        }
    };
    DataManager.prototype.handleServiceCallback = function (data, onComplete, onFailed) {
        if (data) {
            this._data = data;
            this.saveData(data);
            onComplete(this._data);
        }
        else {
            onFailed();
        }
    };
    DataManager.prototype.saveData = function (data) {
        this._storageManager.store(this._key, data);
    };
    DataManager.prototype.resetData = function () {
        this._data = undefined;
        this._storageManager.remove(this._key);
    };
    return DataManager;
}());
export default DataManager;
